'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ToggleableContext = require('../alloy-toggleable/ToggleableContext.js');
var Tabs_module = require('./Tabs.module.scss.js');
var cx = require('classnames');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Tab = function (props) {
    var _a;
    var children = props.children, id = props.id, _b = props.size, size = _b === void 0 ? 'small' : _b;
    var ctx = react.useContext(ToggleableContext.default);
    var isActive = ctx.isActive(id);
    var handleClick = function () { return !isActive && ctx.toggleActive(id); };
    return (jsxRuntime.jsx("li", tslib.__assign({ className: cx__default.default('col d-flex align-items-end', Tabs_module.default['tab-button-list-item']) }, { children: jsxRuntime.jsx("button", tslib.__assign({ role: "tab", type: "button", onClick: handleClick, className: cx__default.default('btn', Tabs_module.default['tab-button'], (_a = {},
                _a[Tabs_module.default.active] = isActive,
                _a['btn-lg'] = size === 'large',
                _a['btn-sm'] = size === 'small',
                _a)), "aria-selected": isActive, "aria-controls": "tab-panel-".concat(id), id: "tab-".concat(id), "data-tabid": id, tabIndex: isActive ? 0 : -1 }, { children: jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default(Tabs_module.default['tab-button-text'], 'text-line-clamp--2') }, { children: children })) })) })));
};

exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map
